import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'ketranslate',
  pure: false,
})
export class KetranslatePipe implements PipeTransform {
  constructor(private _TranslateService: TranslateService) {}
  transform(key_lang: string, value_1: string, value_2: string): any {
    let current_transalte: string = this._TranslateService.instant(
      key_lang,
      this._TranslateService.currentLang
    );
    if (value_1) current_transalte = current_transalte.replace('$1', value_1);
    if (value_2) current_transalte = current_transalte.replace('$2', value_2);
    return current_transalte;
  }
}
